<template>
    <div id = 'digitizeBody'>
        <div class="centered white-text">
            <h3 style="color: #F0F0F0"> {{ $t('digitizeBody.digitizeBodyText') }} </h3>
        </div>
    </div>
</template>

<script>
export default {
    name: 'digitizeBody'
}
</script>